import { useCreationStore } from '../../lib/creationStore'

export function StepAppearance() {
  const store = useCreationStore()

  return (
    <div>
      <h3>Step 3: Appearance</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
        <div>
          <label>Height (inches)</label><br />
          <input type="number" value={store.height_inches}
            onChange={e => store.setField('height_inches', parseInt(e.target.value) || 60)}
            style={{ width: '100%', padding: '0.4rem' }} />
          <span style={{ fontSize: '0.8rem', color: '#666' }}>
            {' '}{Math.floor(store.height_inches / 12)}'{store.height_inches % 12}"
          </span>
        </div>
        <div>
          <label>Frame</label><br />
          <select value={store.frame} onChange={e => store.setField('frame', e.target.value)}
            style={{ width: '100%', padding: '0.4rem' }}>
            {['Scant','Light','Medium','Heavy','Massive'].map(f =>
              <option key={f} value={f}>{f}</option>
            )}
          </select>
        </div>
        <div>
          <label>Weight (lbs)</label><br />
          <input type="number" value={store.weight_lbs}
            onChange={e => store.setField('weight_lbs', parseInt(e.target.value) || 100)}
            style={{ width: '100%', padding: '0.4rem' }} />
        </div>
        <div>
          <label>Comeliness (1–20)</label><br />
          <input type="number" min={1} max={20} value={store.comeliness}
            onChange={e => store.setField('comeliness', parseInt(e.target.value) || 10)}
            style={{ width: '100%', padding: '0.4rem' }} />
        </div>
        <div>
          <label>Complexion</label><br />
          <input value={store.complexion} onChange={e => store.setField('complexion', e.target.value)}
            style={{ width: '100%', padding: '0.4rem' }} />
        </div>
        <div>
          <label>Hair Colour</label><br />
          <input value={store.hair_color} onChange={e => store.setField('hair_color', e.target.value)}
            style={{ width: '100%', padding: '0.4rem' }} />
        </div>
        <div>
          <label>Eye Colour</label><br />
          <input value={store.eye_color} onChange={e => store.setField('eye_color', e.target.value)}
            style={{ width: '100%', padding: '0.4rem' }} />
        </div>
      </div>
    </div>
  )
}
